import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReceiptsPaginationWrapper = styled.section`
  display: flex;
  justify-content: flex-end;
  margin-top: ${Spacing.S24};
`
